import $ from 'jquery';

$(document).ready(() => {
  if (getQueryParameter('update')) {
    let width = $(window).width();
    updateFavoriteAfterRedirect(width);
  }
});

const updateFavoriteAfterRedirect = (width) => {
  if (null && width < 992) {
    $('.social-mobile button[data-user-favorite]').trigger('click', event);
  } else {
    $('.social-desktop button[data-user-favorite]').trigger('click', event);
  }
};

const getQueryParameter = (param) =>
  new URLSearchParams(document.location.search.substring(1)).get(param);
